import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BREAK_TYPE_ENUM } from '../../../../../constants/lookup/common/break-type.enum';
import { DateUtil } from '../../../../../core/utils/date-util';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { CountType } from '../../pages/shift-info-main/shift-info-main.constant';
import { ShiftBreakDetailsComponent } from '../shift-break-details/shift-break-details.component';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';
import { MasterService } from '../../../../../state/master/services/master.service';

@Component({
  standalone: false,
  selector: 'kt-shift-details',
  templateUrl: './shift-details.component.html',
  styleUrls: ['./shift-details.component.scss'],
})
export class ShiftDetailsComponent extends ModalBaseClass implements OnInit {
  mathRef = Math;
  @Input() shiftDetails = null;
  @Input() shiftAllInfo = null;
  @Input() showExtraDetails = true;
  @Input() showDateDetails = true;
  @Output() eOpenModal = new EventEmitter<any>();
  countRef = CountType;
  currentDate = null;
  permissionV2 = PERMISSIONV2
  masterBusinessLabel = MasterService.masterBusinessLabel

  ngOnInit() {
    const dateFormat = LocalStorageUtil.getDateFormat();
    const timeFormat = LocalStorageUtil.getTimeFormat();
    this.currentDate = DateUtil.getCurrentDateTimeWithLocationTimezone(this.shiftDetails.location.location_fk_timezone_name).format(`${dateFormat} ${timeFormat}`);
  }
  restBreakHandler() {
    this.openPopUp(ShiftBreakDetailsComponent, { breaks: this.shiftDetails.rest_break, type: BREAK_TYPE_ENUM.MealBreak }, { centered: true, size: 'md', backdrop: 'static' });
  }

  mealBreakHandler() {
    this.openPopUp(ShiftBreakDetailsComponent, { breaks: this.shiftDetails.meal_break, type: BREAK_TYPE_ENUM.RestBreak }, { centered: true, size: 'md', backdrop: 'static' });
  }

  openModal(modalType) {
    this.eOpenModal.emit(modalType);
  }
}
